export class AppSettings {
    userGroup : string = "ADMIN";
    userName : string = "";
    lastUsedToken: string = "";
}